module.exports = __webpack_public_path__ + "static/media/ApercuPro-LightItalic.cf787f34.woff";